export const LOGIN = "/users/sign_in"

export const SEARCH = "/search/classes"

// ActiveAdmin, and the impersonation an administrator ends with DELETE.
export const ADMIN = "/admin"
export const IMPERSONATION = "/admin/impersonation"

export const STUDENT_PROFILE = "/profile/student/:userTypeId"

export const SCHOOLS = "/schools"

export const DASHBOARD = "/dashboard"

export const TEACHER_ASSESSMENT = "/teacher/:teacherId/assessment"
export const TEACHER_FEEDBACK = "/teacher/:teacherId/feedback"

export const PROFILE_PATH = (
  userType: "student" | "teacher" | "school_admin",
  userId: number,
) => `/profile/${userType}/${userId}`

export const TEACHER_DASHBOARD_PATH = (id: string | number) =>
  `/educators/teachers/${id}/dashboard`
export const TEACHER_TIMETABLE_PATH = (id: string | number) =>
  `/educators/teachers/${id}/timetable`
export const TEACHER_CLASSES_PATH = (id: string | number) =>
  `/educators/teachers/${id}/legacy_classes`

export const SEARCH_CLASSES_RESULT_PATH = (id: string | number) =>
  `/search/classes/${id}`

export const TEACHER_ASSESSMENT_PATH = (id: string | number) =>
  `/teacher/${id}/assessment`
export const TEACHER_FEEDBACK_PATH = (id: string | number) =>
  `/teacher/${id}/feedback`

export const SCHOOL_PROFILE_PATH = (id: string | number) =>
  `/learners/schools/${id}/school_profile/edit`
